import { render, staticRenderFns } from "./NewsTable.vue?vue&type=template&id=1bbb1e27&scoped=true&"
import script from "./NewsTable.vue?vue&type=script&lang=js&"
export * from "./NewsTable.vue?vue&type=script&lang=js&"
import style0 from "./NewsTable.vue?vue&type=style&index=0&id=1bbb1e27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb1e27",
  null
  
)

export default component.exports